import { Box, Heading, Input, Button, Text, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const [valid, setValid] = useState(true);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) { setValid(false); return; }
    fetch(`${API_BASE}/auth/reset-password/verify?token=${encodeURIComponent(token)}`)
      .then(r => setValid(r.ok))
      .catch(() => setValid(false));
  }, [token]);

  const submit = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/auth/reset-password`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({ token, new_password: pw }),
      });
      if (!res.ok) throw new Error();
      toast({ title: "Password updated. Please log in.", status: "success" });
      navigate("/login");
    } catch {
      toast({ title: "Invalid or expired link.", status: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxW="md" mx="auto" mt={16} p={6} borderWidth="1px" borderRadius="lg">
      <Heading size="md" mb={4}>Reset password</Heading>
      {valid ? (
        <>
          <Input placeholder="New password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} mb={3}/>
          <Button colorScheme="green" onClick={submit} isLoading={loading} isDisabled={!pw}>Update password</Button>
        </>
      ) : (
        <Text color="red.500">This reset link is invalid or expired.</Text>
      )}
    </Box>
  );
}
